import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalEditarTrabajadorPage } from './modal-editar-trabajador.page';

const routes: Routes = [
  {
    path: '',
    component: ModalEditarTrabajadorPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalEditarTrabajadorPageRoutingModule {}
